import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BusinessesServices from "../services/Businesses.Service"

export const loadBusiness = createAsyncThunk("business/list", async ()=>{
  const response = await BusinessesServices.loadBusiness()
  return response
})

export const saveBusinessInformation = createAsyncThunk("business/save", async (formData) => {
  const response =  await BusinessesServices.saveBusinessData(formData)
  return response;
})

export const getBusinessBranches = createAsyncThunk("businesses-branches", async (businessId)=>{
  const response = await BusinessesServices.getBusinessBranches(businessId);
  return response;
});

const BusinessesSlices = createSlice({
  name:"Businesses",
  initialState:{
    selectedBusiness:{},
    list:[],
    userBusinessData:[],
    formData:[],
    businessBranches:[],
    success:false,
    error:false,
    loading:false,
    message:""
  },
  reducers:{
    setSelectedBusiness: (state) => {
      const selectedBusiness = localStorage.getItem("SelectedBusiness")
      state.selectedBusiness = JSON.parse(selectedBusiness)
    },
    setFromData: (state, action) =>{
      let businessSaveTmp = localStorage.getItem("businessSaveTmp",)
      let temp = businessSaveTmp?JSON.parse(businessSaveTmp):{}
      temp = {...temp, ...action.payload}
      localStorage.setItem("businessSaveTmp", JSON.stringify(temp))
      state.formData = temp
    },
    removeLocalData:(state)=>{
      localStorage.removeItem("businessSaveTmp")
      state.formData = []
    }
  },
  extraReducers:{
    [loadBusiness.rejected] : (state, action) => {
      state.loading = false
      state.error = action?.payload?.success?
        action?.payload?.message:
        action?.payload?.error;
      //k,nbbghjukklstate.message = action.

    },
    [loadBusiness.pending] : (state) => {
      state.loading = true
    },
    [loadBusiness.fulfilled] : (state, action) => {
      state.loading = false
      state.success = true;
      state.userBusinessData = action.payload?.data
    },

    [saveBusinessInformation.pending] : (state) => {
      state.loading = true
    },
    [saveBusinessInformation.rejected] : (state, action) => {
      state.loading = false
      state.error = true;
      //state.success = false
      state.message = action.payload.success?action.payload.message:action.payload.error;
    },
    [saveBusinessInformation.fulfilled] : (state, action) => {
      state.loading = false
      console.log(action.payload)
      if(action.payload.success){
        state.error = !action.payload.success
        state.success = action.payload.success
        state.message = action.payload.message
      }else{
        state.success = action.payload.success;
        state.error = !action.payload.success
        if(action.payload.error){
          state.message = action.payload.error
        }
        //state.userBusinessData = action.payload
      }
    },
    [getBusinessBranches.rejected] : (state, action) => {
      state.loading = false
      state.error = action?.payload?.success?
        action?.payload?.message:
        action?.payload?.error;
    },
    [getBusinessBranches.pending] : (state) => {
      state.loading = true
    },
    [getBusinessBranches.fulfilled] : (state, action) => {
      state.loading = false
      state.success = true;
      state.businessBranches = action.payload?.data
    }
  }
})


export const {setFromData, removeLocalData, setSelectedBusiness} = BusinessesSlices.actions
export default BusinessesSlices.reducer;